export const adminCatalogMessages = {
  kk: {
    catalog: {
      common: {
        all: 'Барлығы',
        categories: 'Санаттар',
        category: 'Санат',
        supplier: 'Жеткізуші',
        name: 'Атауы',
        description: 'Сипаттамасы',
        quantity: 'Саны',
        stock: 'Қалдық',
        cost: 'Өзіндік құны',
        retailPrice: 'Баға',
        price: 'Бағасы',
        edit: 'Өңдеу',
        delete: 'Жою',
        cancel: 'Бас тарту',
        save: 'Сақтау',
        saved: 'Сақталды',
        deleting: 'Жойылуда...',
        saving: 'Сақталуда...',
        close: 'Жабу',
        loadingProducts: 'Тауарлар жүктелуде...',
        searchByName: 'Атауы бойынша іздеу...',
      },
      products: {
        title: 'Тауарлар',
        subtitle: 'Каталог пен бағаларды басқару',
        add: 'Тауар қосу',
        backToCash: 'Кассаға',
        noResults: 'Тауарлар табылмады',
        noResultsHint: 'Тауар қосыңыз немесе басқа санатты таңдаңыз',
        pageInfo: 'Бет {page} / {count} · барлығы {total}',
        deleteTitle: 'Тауарды жою керек пе?',
        deleteWarning: 'Бұл әрекетті болдырмау мүмкін емес.',
        editTitle: 'Тауарды өңдеу',
        createTitle: 'Тауар қосу',
        barcode: 'Штрихкод',
        hasBarcode: 'Тауарда штрихкод бар',
        barcodeAutoHint: 'Штрихкодты жүйе автоматты түрде жасайды',
        barcodeHint: 'Сканермен оқуға немесе қолмен іздеуге болады',
        markup: 'Үстеме, %',
        retailAutoHint: 'Бөлшек бағаны қолмен жазыңыз немесе үстеме % бойынша есептеледі',
        retailRoundedHint: 'Бағаны өзіңіз жазыңыз. Үстеме % толтырылса — есептеледі',
        measurementType: 'Өлшем түрі',
        enterCost: 'Өзіндік құнын көрсетіңіз',
        enterPrice: 'Бағаны көрсетіңіз',
        enterMarkup: 'Үстеме пайызын көрсетіңіз',
        retailCalculationFailed: 'Бөлшек бағаны есептеу мүмкін болмады',
        deleted: 'Жойылды',
        selectForLabels: 'Жапсырмаға таңдау',
        selectedForLabels: '{count} тауар таңдалды',
        printLabels: 'Жапсырмаларды басып шығару',
        printOneLabel: 'Ценник',
        labelsTitle: 'Баға жапсырмалары',
        labelsHint: 'Пунктир сызықтар бойынша қиып алыңыз',
        barcodeMissing: 'Штрихкоды бар тауарды таңдаңыз',
        barcodeSkipped: '{count} тауарда штрихкод жоқ — жапсырмаға қосылмады',
        printOrSavePdf: 'Басып шығару / PDF сақтау',
        closeLabels: 'Жабу',
        downloadLabels: 'A4 PDF жүктеу',
        labelSize: 'Жапсырма өлшемі',
        labelSizeMini: 'Өте ықшам — 38 × 22 мм (60 дана/A4)',
        labelSizeCompact: 'Ықшам — 48 × 30 мм (36 дана/A4)',
        labelSizeStandard: 'Стандарт — 60 × 40 мм (21 дана/A4)',
        labelSizeLarge: 'Үлкен — 90 × 55 мм (10 дана/A4)',
        labelSizeRoll25x15: 'Ролик 25 × 15 мм × 2 (58 мм лента)',
        labelSizeRoll25x20: 'Ролик 25 × 20 мм × 2 (58 мм лента)',
        labelSizeRoll30x20: 'Ролик 30 × 20 мм × 2 (58–60 мм лента)',
        labelSizeRoll30x25: 'Ролик 30 × 25 мм × 2 (58–60 мм лента)',
        labelsPerPage: 'Бір парақта: {count} жапсырма',
        labelsHintRoll: 'Термолента 58 мм, екі баған. Баға жеңілдікпен көрсетіледі.',
        productDiscount: 'Тауарға жеңілдік',
        applyProductDiscount: 'Осы тауарға жеңілдік қолдану',
        discountValue: 'Сома',
        discountTypePercent: 'Пайыз (%)',
        discountTypeAmount: 'Сома (₸)',
        supplierHint: 'Қажет болса жеткізушіні таңдаңыз',
        formDetails: 'Тауар туралы',
        formPricing: 'Баға және қалдық',
        formExpenses: 'Шығындар',
        formByproducts: 'Бірге сатылатын',
        formWastes: 'Қалдықтар / отход',
        formDiscount: 'Жеңілдік',
        formModifiers: 'Модификаторлар',
        expensesHint: 'Шығындарды теңгемен көрсетіңіз. + арқылы бірнеше жол қосуға болады',
        byproductsHint: 'Тушкамен бірге сатылатын бөліктер (мысалы: ішек). Бұл отход емес',
        wastesHint: 'Отход атауы және саны — шт немесе кг (шығын / жоғалту)',
        expensesEmpty: 'Шығындар қосылмаған',
        byproductsEmpty: 'Бірге сатылатын бөліктер қосылмаған',
        wastesEmpty: 'Отход қосылмаған',
        addExpense: 'Шығын қосу',
        addByproduct: 'Бірге сатылатын қосу',
        addWaste: 'Отход қосу',
        expenseName: 'Шығын атауы',
        expenseNamePlaceholder: 'Мысалы: Орау',
        expenseAmount: 'Сома',
        byproductName: 'Атауы',
        byproductNamePlaceholder: 'Мысалы: Ішек',
        wasteName: 'Отход атауы',
        wasteNamePlaceholder: 'Мысалы: Кесінді',
        unitPcs: 'шт',
        unitKg: 'кг',
        modifiersHint: 'Осы тауарға қолжетімді қосымшалар. Бір модификаторды бірнеше тауарға тіркеуге болады.',
        modifiersEmpty: 'Алдымен «Модификаторлар» бөлімінде жасаңыз',
        selectModifiers: 'Модификаторларды таңдау',
        formDescription: 'Қосымша ақпарат',
        productPhoto: 'Тауар суреті',
        hasProductPhoto: 'Тауар суретін қосу (міндетті емес)',
        uploadPhoto: 'Суретті таңдау',
        changePhoto: 'Суретті ауыстыру',
        removePhoto: 'Суретті өшіру',
        photoHint: 'JPG, PNG немесе WebP · 10 МБ дейін',
        photoTooLarge: 'Сурет көлемі 10 МБ-тан аспауы керек',
        noProductDiscount: 'Жеңілдіксіз',
        labelOldPrice: 'Бұрынғы баға',
        sortOrder: 'Кассадағы реті',
        sortOrderHint: 'Сан неғұрлым аз болса, тауар санатта соғұрлым жоғары тұрады (0 — бірінші)',
        settlementAction: 'Есеп жасау',
        settlementTitle: 'Жеткізушімен есеп',
        settlementDone: 'Есеп жасалды',
        settlementPartial: 'Ішінара есеп',
        settlementOpen: 'Есеп күтілуде',
        settlementHistoryQty: 'Бастапқы салмақ / саны',
        settlementDueTotal: 'Жеткізушіге қарыз',
        settlementSettledQty: 'Есептелген',
        settlementStockNow: 'Қазіргі қалдық',
        settlementRemaining: 'Есепке қалған',
        settlementConfirmTitle: 'Есепті растау',
        settlementPartialHint: 'Соманы қолмен жазыңыз. Толық немесе ішінара есептеуге болады',
        settlementAmountLabel: 'Есептелетін сома',
        settlementAmountHint: 'Қалған: {amount} ₸',
        settlementFillRemaining: 'Барлық қалған сома',
        settlementClearAmount: 'Тазалау',
        settlementPayNow: 'Қазір есептеледі',
        settlementNote: 'Ескертпе (міндетті емес)',
        settlementHistory: 'Есеп тарихы',
        settlementConfirm: 'Есеп жасалды деп растау',
        settlementEditTitle: 'Есепті өңдеу',
        settlementCancelEdit: 'Өңдеуден бас тарту',
        settlementSaved: 'Есеп сақталды',
        settlementDeleted: 'Есеп жойылды',
        settlementDeleteTitle: 'Есепті жою керек пе?',
        settlementDeleteWarning: 'Қате енгізілген жазба жойылады, сома қарызға қайтады.',
        settlementAmountInvalid: 'Соманы дұрыс көрсетіңіз',
        settlementAmountTooMuch: 'Қалғаннан артық болмауы керек: {max} ₸',
      },
      barcodes: {
        title: 'Штрихкод генераторы',
        subtitle: 'Санды енгізіңіз немесе кездейсоқ код жасаңыз, өлшемі мен санын таңдап, басып шығарыңыз',
        modeManual: 'Қолмен енгізу',
        modeRandom: 'Кездейсоқ',
        format: 'Штрихкод форматы',
        formatEan13: 'EAN-13 (13 сан, дүкендер үшін)',
        formatEan8: 'EAN-8 (8 сан, қысқа)',
        formatCode128: 'CODE 128 (кез келген ұзындық)',
        hint_ean13: '12 сан енгізіңіз — бақылау саны автоматты қосылады. Немесе толық 13 сан.',
        hint_ean8: '7 сан енгізіңіз — бақылау саны автоматты қосылады. Немесе толық 8 сан.',
        hint_code128: 'Кез келген сандар, 32 таңбаға дейін',
        code: 'Штрихкод сандары',
        errorDigits: 'Тек сандар енгізіңіз',
        errorEan13Length: 'EAN-13 үшін 12 немесе 13 сан керек',
        errorEan8Length: 'EAN-8 үшін 7 немесе 8 сан керек',
        errorChecksum: 'Бақылау саны қате — соңғы сан {digit} болуы керек',
        errorCode128Length: '{count} саннан аспауы керек',
        generatedCode: 'Жасалған код',
        firstCode: 'Бірінші код',
        regenerate: 'Жаңа код',
        uniqueCodes: 'Әр жапсырмаға жеке код',
        labelSizeSingle30x20: 'Жапсырма 30 × 20 мм, саңылау 3 мм (этикетка принтері)',
        labelSizeSingle40x30: 'Жапсырма 40 × 30 мм (этикетка принтері)',
        labelSizeSingle58x30: 'Жапсырма 58 × 30 мм (этикетка принтері)',
        labelSizeSingle58x40: 'Жапсырма 58 × 40 мм (этикетка принтері)',
        labelSizeCustom: 'Өз өлшемім…',
        customWidth: 'Ені, мм',
        customHeight: 'Биіктігі, мм',
        customColumns: 'Бағандар',
        quantity: 'Жапсырма саны',
        showDigits: 'Штрихкод астында сандарды көрсету',
        copy: 'Көшіру',
        copied: 'Код көшірілді',
        print: 'Басып шығару ({count} дана)',
        preview: 'Алдын ала қарау',
        summary: '{labels} жапсырма · {pages} бет',
        emptyTitle: 'Штрихкод сандарын енгізіңіз',
        popupBlocked: 'Басып шығару үшін қалқымалы терезелерге рұқсат беріңіз',
        barcodeScale: 'Штрихкод масштабы',
        labelGap: 'Жапсырмалар арасындағы саңылау, мм',
        labelGapHint: 'Әдетте 2 мм. 0 — тұтас лента (чек қағазы)',
        browserPrint: 'PDF',
        browserPrintHint: 'Браузер арқылы басып шығару немесе PDF сақтау',
        sentToPrinter: '{count} жапсырма принтерге жіберілді',
        agentOffline: 'Басып шығару агенті іске қосылмаған немесе ескі нұсқа — браузер арқылы басып шығарамыз',
        printFailed: 'Жапсырмаларды басып шығару мүмкін болмады',
      },
      priceTags: {
        title: 'Баға жапсырмалары',
        subtitle: 'Тауарларды таңдап, қарапайым бағаны немесе жеңілдікпен бағаны басып шығарыңыз',
        modeSale: 'Жеңілдікпен',
        modeRegular: 'Қарапайым баға',
        selected: 'Таңдалды: {count}',
        selectVisible: 'Бетті таңдау',
        clearVisible: 'Бетті алу',
        showName: 'Атауын көрсету',
        showBarcode: 'Штрихкодты көрсету',
        showOldPrice: 'Ескі бағаны сызып көрсету',
        weight: 'Салмақ',
        readWeight: 'Салмақ',
        perKg: '{price} ₸/кг',
        weightRead: 'Салмақ: {value}',
        weightEmpty: 'Таразы 0 кг көрсетеді',
        weightReadFailed: 'Салмақты алу мүмкін болмады. ves_agent.py іске қосыңыз',
        weightNeedProduct: 'Алдымен тауарды таңдаңыз',
        emptyTitle: 'Тауарларды таңдаңыз',
        emptyHint: 'Сол жақтан тауар белгілеңіз — оң жақта ценник шығады',
      },
      categories: {
        title: 'Санаттар',
        subtitle: 'Касса мен қоймаға арналған тауар топтары',
        add: 'Санат қосу',
        empty: 'Санаттар әлі жоқ',
        emptyHint: 'Тауарлар үшін бірінші санатты жасаңыз',
        editTitle: 'Санатты өңдеу',
        createTitle: 'Жаңа санат',
        editHint: 'Тауарлар тобының атауын өзгертіңіз',
        createHint: 'Кассадағы тауарлар үшін топ жасаңыз',
        namePlaceholder: 'Мысалы: Сусындар',
        deleteTitle: 'Санатты жою керек пе?',
        deleteWarning: 'Әрекетті болдырмау мүмкін емес',
        deleteDescription: '«{name}» санаты жойылады.',
        deleted: 'Санат жойылды',
        deleteFailed: 'Санатты жою мүмкін болмады',
        enterName: 'Атауын енгізіңіз',
      },
      suppliers: {
        title: 'Жеткізушілер',
        subtitle: 'Тауарларға арналған жеткізушілер тізімі',
        add: 'Жеткізуші қосу',
        empty: 'Жеткізушілер әлі жоқ',
        emptyHint: 'Алғашқы жеткізушіні қосыңыз — кейін тауарда таңдайсыз',
        editTitle: 'Жеткізушіні өңдеу',
        createTitle: 'Жаңа жеткізуші',
        editHint: 'Атауын немесе байланыс деректерін өзгертіңіз',
        createHint: 'Тауарларға байланатын жеткізуші жасаңыз',
        namePlaceholder: 'Мысалы: Астана Food',
        phone: 'Телефон',
        phonePlaceholder: '87001234567',
        note: 'Ескертпе',
        notePlaceholder: 'Қосымша ақпарат (міндетті емес)',
        deleteTitle: 'Жеткізушіні жою керек пе?',
        deleteWarning: 'Әрекетті болдырмау мүмкін емес',
        deleteDescription: '«{name}» жеткізушісі жойылады. Тауарлардан байланыс алынады.',
        deleted: 'Жеткізуші жойылды',
        deleteFailed: 'Жеткізушіні жою мүмкін болмады',
        enterName: 'Атауын енгізіңіз',
      },
      menu: {
        title: 'Мәзір JSON',
        subtitle: 'Каталогты JSON форматында экспорттау және импорттау',
        exportTitle: 'Экспорт',
        exportHint: 'Ағымдағы санаттар мен тауарларды sogym_menu.json форматында жүктеу',
        exportBtn: 'JSON жүктеу',
        exporting: 'Жүктелуде...',
        exportDone: 'Мәзір жүктелді',
        exportFailed: 'Экспорт сәтсіз аяқталды',
        importTitle: 'Импорт',
        importHint: 'JSON файлдан санаттар мен тауарларды жасау. Бар тауарлардың бағасы жаңартылады',
        chooseFile: 'JSON файл таңдау',
        importBtn: 'Импорттау',
        importing: 'Импортталуда...',
        importDone: 'Мәзір импортталды',
        importFailed: 'Импорт сәтсіз аяқталды',
        resultTitle: 'Нәтиже',
        resultCategories: 'Жаңа санаттар: {count}',
        resultCreated: 'Жаңа тауарлар: {count}',
        resultUpdated: 'Жаңартылған тауарлар: {count}',
        formatTitle: 'JSON форматы',
      },
      payments: {
        title: 'Төлем түрлері',
        subtitle: 'Кассаға арналған төлем әдістері',
        add: 'Түр қосу',
        turnOff: 'Жасыру',
        turnOn: 'Көрсету',
        inactive: 'жасырын',
        empty: 'Төлем түрлері әлі жоқ',
        emptyHint: 'Кассаға төлем әдістерін қосыңыз',
        editTitle: 'Төлем түрін өңдеу',
        createTitle: 'Төлем түрін қосу',
        code: 'Код (міндетті емес)',
        codeHint: 'Мысалы: kaspi, nal. Бос болса — автоматты түрде жасалады',
        deleteTitle: 'Төлем түрін жою керек пе?',
        deleteDescription: '«{name}» түрі жойылады. Бұл әрекетті болдырмау мүмкін емес.',
        deleted: 'Төлем түрі жойылды',
        deleteFailed: 'Төлем түрін жою мүмкін болмады',
        turnedOff: 'Төлем түрі кассадан жасырылды',
        turnedOn: 'Төлем түрі кассада көрсетіледі',
      },
      discounts: {
        title: 'Жеңілдіктер',
        subtitle: 'Кассаға арналған белгіленген сомалар мен пайыздар',
        add: 'Жеңілдік қосу',
        turnOff: 'Өшіру',
        turnOn: 'Қосу',
        inactive: 'өшірілген',
        empty: 'Жеңілдіктер әлі жоқ',
        emptyHint: 'Жеңілдік жасаңыз — ол кассада пайда болады',
        editTitle: 'Жеңілдікті өңдеу',
        createTitle: 'Жеңілдік қосу',
        namePlaceholder: 'Мысалы: Тұрақты клиент',
        amount: 'Сома (₸)',
        percent: 'Пайыз (%)',
        discountPercent: 'Жеңілдік пайызы',
        discountAmount: 'Жеңілдік сомасы, ₸',
        percentExample: 'Мысалы: 5% — 2000 ₸ тауар 1900 ₸ тұрады',
        amountExample: 'Мысалы: 100 ₸ — 2000 ₸ тауар 1900 ₸ тұрады (дана/кг/л үшін)',
        deleteTitle: 'Жеңілдікті жою керек пе?',
        deleteDescription: '«{name}» жеңілдігі жойылады. Ол ескі чектерде сақталады.',
        turnedOff: 'Жеңілдік өшірілді',
        turnedOn: 'Жеңілдік қосылды',
        deleted: 'Жеңілдік жойылды',
        deleteFailed: 'Жеңілдікті жою мүмкін болмады',
        enterValue: 'Жеңілдік мөлшерін көрсетіңіз',
        invalidPercent: 'Пайыз 100-ден аз болуы керек',
      },
      modifiers: {
        title: 'Модификаторлар',
        subtitle: 'Қосымша опциялар — бірнеше тауарға ортақ (сироп, размер және т.б.)',
        add: 'Модификатор қосу',
        turnOff: 'Өшіру',
        turnOn: 'Қосу',
        inactive: 'өшірілген',
        empty: 'Модификаторлар әлі жоқ',
        emptyHint: 'Жасаңыз, сосын тауарға тіркеңіз — кассада пайда болады',
        editTitle: 'Модификаторды өңдеу',
        createTitle: 'Модификатор қосу',
        namePlaceholder: 'Мысалы: Ваниль сиропы',
        price: 'Қосымша баға, ₸',
        priceHint: 'Тауар бағасына қосылады (дана/кг/л үшін бір бірлікке)',
        deleteTitle: 'Модификаторды жою керек пе?',
        deleteDescription: '«{name}» жойылады. Ескі чектерде атауы сақталады.',
        turnedOff: 'Модификатор өшірілді',
        turnedOn: 'Модификатор қосылды',
        deleted: 'Модификатор жойылды',
        deleteFailed: 'Модификаторды жою мүмкін болмады',
        enterPrice: 'Бағасын көрсетіңіз',
      },
      stock: {
        title: 'Қойма',
        subtitle: 'Қалдықтар, сату тарихы және толықтыру',
        history: 'Тарих',
        replenish: 'Толықтыру',
        retail: 'Бөлшек сауда',
        noCategories: 'Санаттар жоқ',
        noCategoriesHint: 'Алдымен санат жасаңыз',
        nothingFound: 'Ештеңе табылмады',
        searchHint: 'Басқа сұрауды қолданып көріңіз',
        noProducts: 'Санатта тауарлар жоқ',
        noProductsHint: 'Басқа санатты таңдаңыз немесе тауар қосыңыз',
        historyTitle: 'Тарих — {name}',
        sold: 'Сатылды:',
        profit: 'Пайда:',
        historyEmpty: 'Сату тарихы бос',
        replenishTitle: 'Толықтыру — {name}',
        enterQuantity: 'Санын көрсетіңіз',
        enterPriceAndCost: 'Бағасы мен өзіндік құнын көрсетіңіз',
        stockUpdated: 'Қалдық жаңартылды',
        waste: 'Отход / шығын',
        wasteTitle: 'Отход — {name}',
        wasteHint: 'Қалдық: {stock} {unit}. Списау қалдықтан алынады.',
        wasteQty: 'Отход мөлшері ({unit})',
        wasteNote: 'Себебі (міндетті емес)',
        wasteCostPreview: 'Отход сомасы (өзіндік құн)',
        wasteSubmit: 'Списау',
        wasteSaved: 'Отход списан',
        wasteTooMuch: 'Қалдықтан артық списауға болмайды ({stock})',
        wasteLabel: 'Отход:',
        wasteCost: 'Отход сомасы:',
      },
    },
  },
  ru: {
    catalog: {
      common: {
        all: 'Все',
        categories: 'Категории',
        category: 'Категория',
        supplier: 'Поставщик',
        name: 'Название',
        description: 'Описание',
        quantity: 'Количество',
        stock: 'Остаток',
        cost: 'Себестоимость',
        retailPrice: 'Цена',
        price: 'Цена',
        edit: 'Изменить',
        delete: 'Удалить',
        cancel: 'Отмена',
        save: 'Сохранить',
        saved: 'Сохранено',
        deleting: 'Удаление...',
        saving: 'Сохранение...',
        close: 'Закрыть',
        loadingProducts: 'Загрузка товаров...',
        searchByName: 'Поиск по названию...',
      },
      products: {
        title: 'Товары',
        subtitle: 'Управление каталогом и ценами',
        add: 'Добавить товар',
        backToCash: 'К кассе',
        noResults: 'Товары не найдены',
        noResultsHint: 'Добавьте товар или выберите другую категорию',
        pageInfo: 'Страница {page} из {count} · всего {total}',
        deleteTitle: 'Удалить товар?',
        deleteWarning: 'Это действие нельзя отменить.',
        editTitle: 'Редактировать товар',
        createTitle: 'Добавить товар',
        barcode: 'Штрихкод',
        hasBarcode: 'У товара есть штрихкод',
        barcodeAutoHint: 'Штрихкод будет сгенерирован системой автоматически',
        barcodeHint: 'Можно сканировать или искать вручную',
        markup: 'Наценка, %',
        retailAutoHint: 'Розничную цену можно указать вручную или посчитать от наценки %',
        retailRoundedHint: 'Введите цену сами. Если заполнить наценку % — посчитается автоматически',
        measurementType: 'Тип измерения',
        enterCost: 'Укажите себестоимость',
        enterPrice: 'Укажите цену',
        enterMarkup: 'Укажите процент наценки',
        retailCalculationFailed: 'Не удалось рассчитать розничную цену',
        deleted: 'Удалено',
        selectForLabels: 'Выбрать для наклеек',
        selectedForLabels: 'Выбрано товаров: {count}',
        printLabels: 'Печать наклеек',
        printOneLabel: 'Ценник',
        labelsTitle: 'Ценники и наклейки',
        labelsHint: 'Разрежьте лист по пунктирным линиям',
        barcodeMissing: 'Выберите товар со штрихкодом',
        barcodeSkipped: 'У {count} товар(ов) нет штрихкода — они не добавлены в наклейки',
        printOrSavePdf: 'Печать / сохранить PDF',
        closeLabels: 'Закрыть',
        downloadLabels: 'Скачать A4 PDF',
        labelSize: 'Размер наклеек',
        labelSizeMini: 'Очень компакт — 38 × 22 мм (60 шт./A4)',
        labelSizeCompact: 'Компакт — 48 × 30 мм (36 шт./A4)',
        labelSizeStandard: 'Стандарт — 60 × 40 мм (21 шт./A4)',
        labelSizeLarge: 'Крупный — 90 × 55 мм (10 шт./A4)',
        labelSizeRoll25x15: 'Ролик 25 × 15 мм × 2 (лента 58 мм)',
        labelSizeRoll25x20: 'Ролик 25 × 20 мм × 2 (лента 58 мм)',
        labelSizeRoll30x20: 'Ролик 30 × 20 мм × 2 (лента 58–60 мм)',
        labelSizeRoll30x25: 'Ролик 30 × 25 мм × 2 (лента 58–60 мм)',
        labelsPerPage: 'На листе: {count} наклеек',
        labelsHintRoll: 'Термолента 58 мм, два столбца. Цена печатается со скидкой, если она есть.',
        productDiscount: 'Скидка на товар',
        applyProductDiscount: 'Применить скидку к этому товару',
        discountValue: 'Размер скидки',
        discountTypePercent: 'Процент (%)',
        discountTypeAmount: 'Сумма (₸)',
        supplierHint: 'При необходимости выберите поставщика',
        formDetails: 'О товаре',
        formPricing: 'Цена и остаток',
        formExpenses: 'Расходы',
        formByproducts: 'Продаётся вместе',
        formWastes: 'Отходы',
        formDiscount: 'Скидка',
        formModifiers: 'Модификаторы',
        expensesHint: 'Укажите расходы в тенге. Через + можно добавить несколько строк',
        byproductsHint: 'Части, которые продаются вместе с товаром (например: кишки). Это не отход',
        wastesHint: 'Название отхода и количество — шт или кг (потери / списание)',
        expensesEmpty: 'Расходы не добавлены',
        byproductsEmpty: 'Совместные позиции не добавлены',
        wastesEmpty: 'Отходы не добавлены',
        addExpense: 'Добавить расход',
        addByproduct: 'Добавить «вместе»',
        addWaste: 'Добавить отход',
        expenseName: 'Название расхода',
        expenseNamePlaceholder: 'Например: Упаковка',
        expenseAmount: 'Сумма',
        byproductName: 'Название',
        byproductNamePlaceholder: 'Например: Кишки',
        wasteName: 'Название отхода',
        wasteNamePlaceholder: 'Например: Обрезки',
        unitPcs: 'шт',
        unitKg: 'кг',
        modifiersHint: 'Доп. опции для этого товара. Один модификатор можно привязать к нескольким товарам.',
        modifiersEmpty: 'Сначала создайте их в разделе «Модификаторы»',
        selectModifiers: 'Выберите модификаторы',
        formDescription: 'Дополнительная информация',
        productPhoto: 'Фото товара',
        hasProductPhoto: 'Добавить фото товара (необязательно)',
        uploadPhoto: 'Выбрать фото',
        changePhoto: 'Заменить фото',
        removePhoto: 'Удалить фото',
        photoHint: 'JPG, PNG или WebP · до 10 МБ',
        photoTooLarge: 'Размер фото не должен превышать 10 МБ',
        noProductDiscount: 'Без скидки',
        labelOldPrice: 'Старая цена',
        sortOrder: 'Порядок на кассе',
        sortOrderHint: 'Чем меньше число, тем выше товар в категории (0 — первым)',
        settlementAction: 'Сделать расчёт',
        settlementTitle: 'Расчёт с поставщиком',
        settlementDone: 'Расчёт сделан',
        settlementPartial: 'Частичный расчёт',
        settlementOpen: 'Ожидает расчёта',
        settlementHistoryQty: 'Исходный вес / кол-во',
        settlementDueTotal: 'Долг поставщику',
        settlementSettledQty: 'Рассчитано',
        settlementStockNow: 'Текущий остаток',
        settlementRemaining: 'Осталось к расчёту',
        settlementConfirmTitle: 'Подтвердить расчёт',
        settlementPartialHint: 'Введите сумму вручную. Можно рассчитать полностью или частично',
        settlementAmountLabel: 'Сумма к расчёту',
        settlementAmountHint: 'Осталось: {amount} ₸',
        settlementFillRemaining: 'Весь остаток',
        settlementClearAmount: 'Очистить',
        settlementPayNow: 'Сейчас к расчёту',
        settlementNote: 'Комментарий (необязательно)',
        settlementHistory: 'История расчётов',
        settlementConfirm: 'Подтвердить расчёт',
        settlementEditTitle: 'Изменить расчёт',
        settlementCancelEdit: 'Отменить изменение',
        settlementSaved: 'Расчёт сохранён',
        settlementDeleted: 'Расчёт удалён',
        settlementDeleteTitle: 'Удалить расчёт?',
        settlementDeleteWarning: 'Ошибочная запись будет удалена, сумма вернётся в долг.',
        settlementAmountInvalid: 'Укажите корректную сумму',
        settlementAmountTooMuch: 'Не больше остатка: {max} ₸',
      },
      barcodes: {
        title: 'Генератор штрихкодов',
        subtitle: 'Введите цифры или сгенерируйте случайный код, выберите размер и количество наклеек и отправьте на печать',
        modeManual: 'Ввести вручную',
        modeRandom: 'Случайный',
        format: 'Формат штрихкода',
        formatEan13: 'EAN-13 (13 цифр, для магазинов)',
        formatEan8: 'EAN-8 (8 цифр, короткий)',
        formatCode128: 'CODE 128 (любая длина)',
        hint_ean13: 'Введите 12 цифр — контрольная добавится автоматически. Или все 13 цифр.',
        hint_ean8: 'Введите 7 цифр — контрольная добавится автоматически. Или все 8 цифр.',
        hint_code128: 'Любые цифры, до 32 символов',
        code: 'Цифры штрихкода',
        errorDigits: 'Вводите только цифры',
        errorEan13Length: 'Для EAN-13 нужно 12 или 13 цифр',
        errorEan8Length: 'Для EAN-8 нужно 7 или 8 цифр',
        errorChecksum: 'Неверная контрольная цифра — последняя должна быть {digit}',
        errorCode128Length: 'Не больше {count} цифр',
        generatedCode: 'Сгенерированный код',
        firstCode: 'Первый код',
        regenerate: 'Новый код',
        uniqueCodes: 'Свой код на каждой наклейке',
        labelSizeSingle30x20: 'Наклейка 30 × 20 мм, зазор 3 мм (принтер этикеток)',
        labelSizeSingle40x30: 'Наклейка 40 × 30 мм (принтер этикеток)',
        labelSizeSingle58x30: 'Наклейка 58 × 30 мм (принтер этикеток)',
        labelSizeSingle58x40: 'Наклейка 58 × 40 мм (принтер этикеток)',
        labelSizeCustom: 'Свой размер…',
        customWidth: 'Ширина, мм',
        customHeight: 'Высота, мм',
        customColumns: 'Колонок',
        quantity: 'Количество наклеек',
        showDigits: 'Показывать цифры под штрихкодом',
        copy: 'Копировать',
        copied: 'Код скопирован',
        print: 'Печать ({count} шт.)',
        preview: 'Предпросмотр',
        summary: '{labels} наклеек · {pages} стр.',
        emptyTitle: 'Введите цифры штрихкода',
        popupBlocked: 'Разрешите всплывающие окна для печати наклеек',
        barcodeScale: 'Масштаб штрихкода',
        labelGap: 'Зазор между наклейками, мм',
        labelGapHint: 'Обычно 2 мм. 0 — сплошная лента (чековая бумага)',
        browserPrint: 'PDF',
        browserPrintHint: 'Печать через браузер или сохранить в PDF',
        sentToPrinter: 'Отправлено на принтер: {count} шт.',
        agentOffline: 'Агент печати не запущен или старой версии — печатаем через браузер',
        printFailed: 'Не удалось напечатать наклейки',
      },
      priceTags: {
        title: 'Ценники',
        subtitle: 'Выберите товары и напечатайте обычную цену или цену со скидкой',
        modeSale: 'Со скидкой',
        modeRegular: 'Обычная цена',
        selected: 'Выбрано: {count}',
        selectVisible: 'Выбрать страницу',
        clearVisible: 'Снять страницу',
        showName: 'Показывать название',
        showBarcode: 'Показывать штрихкод',
        showOldPrice: 'Зачёркивать старую цену',
        weight: 'Вес',
        readWeight: 'Вес',
        perKg: '{price} ₸/кг',
        weightRead: 'Вес: {value}',
        weightEmpty: 'Весы показывают 0 кг',
        weightReadFailed: 'Не удалось получить вес. Запустите ves_agent.py',
        weightNeedProduct: 'Сначала выберите товар',
        emptyTitle: 'Выберите товары',
        emptyHint: 'Отметьте товары слева — справа появится ценник',
      },
      categories: {
        title: 'Категории',
        subtitle: 'Группы товаров для кассы и склада',
        add: 'Добавить категорию',
        empty: 'Категорий пока нет',
        emptyHint: 'Создайте первую категорию для товаров',
        editTitle: 'Редактировать категорию',
        createTitle: 'Новая категория',
        editHint: 'Измените название группы товаров',
        createHint: 'Создайте группу для товаров на кассе',
        namePlaceholder: 'Например: Напитки',
        deleteTitle: 'Удалить категорию?',
        deleteWarning: 'Действие нельзя отменить',
        deleteDescription: 'Категория «{name}» будет удалена.',
        deleted: 'Категория удалена',
        deleteFailed: 'Не удалось удалить категорию',
        enterName: 'Введите название',
      },
      suppliers: {
        title: 'Поставщики',
        subtitle: 'Список поставщиков для товаров',
        add: 'Добавить поставщика',
        empty: 'Поставщиков пока нет',
        emptyHint: 'Создайте первого поставщика — потом выберете его в товаре',
        editTitle: 'Редактировать поставщика',
        createTitle: 'Новый поставщик',
        editHint: 'Измените название или контакты',
        createHint: 'Создайте поставщика для привязки к товарам',
        namePlaceholder: 'Например: Астана Food',
        phone: 'Телефон',
        phonePlaceholder: '87001234567',
        note: 'Заметка',
        notePlaceholder: 'Дополнительная информация (необязательно)',
        deleteTitle: 'Удалить поставщика?',
        deleteWarning: 'Действие нельзя отменить',
        deleteDescription: 'Поставщик «{name}» будет удалён. Связь с товарами снимется.',
        deleted: 'Поставщик удалён',
        deleteFailed: 'Не удалось удалить поставщика',
        enterName: 'Введите название',
      },
      menu: {
        title: 'Меню JSON',
        subtitle: 'Экспорт и импорт каталога в формате JSON',
        exportTitle: 'Экспорт',
        exportHint: 'Скачать текущие категории и товары в формате sogym_menu.json',
        exportBtn: 'Скачать JSON',
        exporting: 'Скачивание...',
        exportDone: 'Меню скачано',
        exportFailed: 'Не удалось экспортировать',
        importTitle: 'Импорт',
        importHint: 'Создать категории и товары из JSON. У существующих товаров обновится цена',
        chooseFile: 'Выбрать JSON файл',
        importBtn: 'Импортировать',
        importing: 'Импорт...',
        importDone: 'Меню импортировано',
        importFailed: 'Не удалось импортировать',
        resultTitle: 'Результат',
        resultCategories: 'Новых категорий: {count}',
        resultCreated: 'Новых товаров: {count}',
        resultUpdated: 'Обновлённых товаров: {count}',
        formatTitle: 'Формат JSON',
      },
      payments: {
        title: 'Типы оплаты',
        subtitle: 'Способы оплаты для кассы',
        add: 'Добавить тип',
        turnOff: 'Скрыть',
        turnOn: 'Показать',
        inactive: 'скрыт',
        empty: 'Типов оплаты пока нет',
        emptyHint: 'Добавьте способы оплаты для кассы',
        editTitle: 'Редактировать тип оплаты',
        createTitle: 'Добавить тип оплаты',
        code: 'Код (необязательно)',
        codeHint: 'Например: kaspi, nal. Если пусто — создастся автоматически',
        deleteTitle: 'Удалить тип оплаты?',
        deleteDescription: 'Тип «{name}» будет удалён. Это действие нельзя отменить.',
        deleted: 'Тип оплаты удалён',
        deleteFailed: 'Не удалось удалить тип оплаты',
        turnedOff: 'Тип оплаты скрыт с кассы',
        turnedOn: 'Тип оплаты снова на кассе',
      },
      discounts: {
        title: 'Скидки',
        subtitle: 'Фиксированные суммы и проценты для кассы',
        add: 'Добавить скидку',
        turnOff: 'Выключить',
        turnOn: 'Включить',
        inactive: 'выключена',
        empty: 'Скидок пока нет',
        emptyHint: 'Создайте скидку — она появится на кассе',
        editTitle: 'Редактировать скидку',
        createTitle: 'Добавить скидку',
        namePlaceholder: 'Например: Постоянный клиент',
        amount: 'Сумма (₸)',
        percent: 'Процент (%)',
        discountPercent: 'Процент скидки',
        discountAmount: 'Сумма скидки, ₸',
        percentExample: 'Пример: 5% — товар за 2000 ₸ будет стоить 1900 ₸',
        amountExample: 'Пример: 100 ₸ — товар за 2000 ₸ будет стоить 1900 ₸ (за шт/кг/л)',
        deleteTitle: 'Удалить скидку?',
        deleteDescription: 'Скидка «{name}» будет удалена. В старых чеках она сохранится.',
        turnedOff: 'Скидка выключена',
        turnedOn: 'Скидка включена',
        deleted: 'Скидка удалена',
        deleteFailed: 'Не удалось удалить скидку',
        enterValue: 'Укажите размер скидки',
        invalidPercent: 'Процент должен быть меньше 100',
      },
      modifiers: {
        title: 'Модификаторы',
        subtitle: 'Доп. опции — общие для нескольких товаров (сироп, размер и т.п.)',
        add: 'Добавить модификатор',
        turnOff: 'Выключить',
        turnOn: 'Включить',
        inactive: 'выключен',
        empty: 'Модификаторов пока нет',
        emptyHint: 'Создайте и привяжите к товарам — появятся на кассе',
        editTitle: 'Редактировать модификатор',
        createTitle: 'Добавить модификатор',
        namePlaceholder: 'Например: Сироп ваниль',
        price: 'Доп. цена, ₸',
        priceHint: 'Прибавляется к цене товара за единицу (шт/кг/л)',
        deleteTitle: 'Удалить модификатор?',
        deleteDescription: '«{name}» будет удалён. В старых чеках название сохранится.',
        turnedOff: 'Модификатор выключен',
        turnedOn: 'Модификатор включён',
        deleted: 'Модификатор удалён',
        deleteFailed: 'Не удалось удалить модификатор',
        enterPrice: 'Укажите цену',
      },
      stock: {
        title: 'Склад',
        subtitle: 'Остатки, история продаж и пополнение',
        history: 'История',
        replenish: 'Пополнить',
        retail: 'Розница',
        noCategories: 'Нет категорий',
        noCategoriesHint: 'Сначала создайте категорию',
        nothingFound: 'Ничего не найдено',
        searchHint: 'Попробуйте другой запрос',
        noProducts: 'В категории нет товаров',
        noProductsHint: 'Выберите другую категорию или добавьте товар',
        historyTitle: 'История — {name}',
        sold: 'Продано:',
        profit: 'Прибыль:',
        historyEmpty: 'История продаж пуста',
        replenishTitle: 'Пополнить — {name}',
        enterQuantity: 'Укажите количество',
        enterPriceAndCost: 'Укажите цену и себестоимость',
        stockUpdated: 'Остаток обновлён',
        waste: 'Отход / расход',
        wasteTitle: 'Отход — {name}',
        wasteHint: 'Остаток: {stock} {unit}. Списание уменьшит склад.',
        wasteQty: 'Количество отхода ({unit})',
        wasteNote: 'Причина (необязательно)',
        wasteCostPreview: 'Сумма отхода (себестоимость)',
        wasteSubmit: 'Списать',
        wasteSaved: 'Отход списан',
        wasteTooMuch: 'Нельзя списать больше остатка ({stock})',
        wasteLabel: 'Отход:',
        wasteCost: 'Сумма отхода:',
      },
    },
  },
}
